import { useMemo } from 'react';

import { endOfWeek, startOfWeek } from 'date-fns';

import { Box, CircularProgress, LineChart } from '@sbv-clients/ui-shared';
import { formatDate } from '@sbv-clients/util-misc';

import { useDashboardHppdHoursGet } from '../../../services/dashboard';
import { transformToLineChart } from './transform';

interface HppdWeeklyReportProps {
  departmentId: number;
  positionId: number;
  startDate: Date;
}

const HppdWeeklyReport = ({
  departmentId,
  positionId,
  ...props
}: HppdWeeklyReportProps) => {
  const [startDate, endDate] = useMemo(
    () => [
      formatDate(startOfWeek(new Date(props.startDate))),
      formatDate(endOfWeek(new Date(props.startDate))),
    ],
    [props.startDate]
  );

  const { data: hppdData, isLoading } = useDashboardHppdHoursGet(
    departmentId,
    positionId,
    startDate,
    endDate
  );

  const graphData = useMemo(() => transformToLineChart(hppdData), [hppdData]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <LineChart
      labels={graphData.labels}
      datasets={graphData.datasets}
      height={100}
      title={'HPPD Weekly Report'}
    />
  );
};

export default HppdWeeklyReport;
